<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card class="rounded-xl">
      <v-card-title class="text-h5 font-weight-bold pa-6 border-bottom">
        Finalizar Venda
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>{{ icons.mdiClose }}</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-6 px-6">
        <div class="text-center mb-6">
           <div class="text-uppercase grey--text text--darken-1 caption font-weight-bold">Total a Pagar</div>
           <div class="text-h3 font-weight-black primary--text mt-1">{{ (totalToPay / 100) | moneyBr }}</div>
        </div>

        <v-select
          v-model="paymentMethod"
          :items="paymentMethods"
          label="Forma de Pagamento"
          outlined
          dense
          :prepend-inner-icon="icons.mdiCreditCardOutline"
        ></v-select>

        <v-text-field
          v-model="amountReceived"
          label="Valor Recebido"
          type="number"
          step="0.01"
          outlined
          dense
          prefix="R$"
          class="mt-2"
          :prepend-inner-icon="icons.mdiCash"
        ></v-text-field>
        
        <v-switch
          v-model="emitInvoice"
          label="Emitir Cupom Fiscal (NFC-e)"
          dense
          hide-details
          class="mt-2"
          color="success"
        ></v-switch>

        <div v-if="change > 0" class="d-flex align-center justify-space-between pa-4 bg-green-50 rounded-lg border-green mt-4">
            <span class="success--text font-weight-bold">TROCO</span>
            <span class="text-h5 font-weight-bold success--text">{{ (change / 100) | moneyBr }}</span>
        </div>

      </v-card-text>

      <v-card-actions class="pa-6 pt-0">
        <v-btn
          block
          x-large
          color="success"
          class="rounded-lg shadow-lg"
          @click="confirmSale"
          :disabled="!isValid"
        >
          Confirmar Pagamento
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose, mdiCreditCardOutline, mdiCash } from '@mdi/js';

export default {
  name: "POSPaymentModal",
  props: {
    totalToPay: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      amountReceived: null,
      paymentMethod: 'money',
      emitInvoice: true, // Default to true
      paymentMethods: [
        { text: 'Dinheiro', value: 'money' },
        { text: 'Cartão de Crédito', value: 'credit_card' },
        { text: 'Cartão de Débito', value: 'debit_card' },
        { text: 'PIX', value: 'pix' },
      ],
      icons: { mdiClose, mdiCreditCardOutline, mdiCash }
    };
  },
  computed: {
    amountReceivedCents() {
       return (parseFloat(this.amountReceived || 0) * 100);
    },
    change() {
      if(!this.amountReceived) return 0;
      return Math.max(0, this.amountReceivedCents - this.totalToPay);
    },
    isValid() {
       return this.paymentMethod && this.amountReceivedCents >= this.totalToPay;
    }
  },
  watch: {
    dialog(val) {
      if(val) {
        // Default received to total
        this.amountReceived = (this.totalToPay / 100).toFixed(2);
        this.emitInvoice = true;
      }
    }
  },
  methods: {
    open() {
      this.dialog = true;
    },
    confirmSale() {
      this.$emit('finish', {
        method: this.paymentMethod,
        received: this.amountReceivedCents,
        change: this.change,
        emit_invoice: this.emitInvoice
      });
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
.bg-green-50 {
  background-color: #f0fdf4;
}
.border-green {
  border: 1px solid #bbf7d0;
}
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
